export default "__VITE_ASSET__8e3889eb__"